const size = {
	mobileS: '320px',
	mobileM: '375px',
	mobileL: '425px',
	mobileXL: '639px',
	tablet: '768px',
	laptop: '1024px',
	laptopL: '1440px',
	desktop: '2560px',
}

export const device = {
	mobileS: `(min-width: ${size.mobileS})`,
	mobileM: `(min-width: ${size.mobileM})`,
	mobileL: `(min-width: ${size.mobileL})`,
	mobileXL: `(min-width: ${size.mobileXL})`,
	tablet: `(min-width: ${size.tablet})`,
	laptop: `(min-width: ${size.laptop})`,
	laptopL: `(min-width: ${size.laptopL})`,
	desktop: `(min-width: ${size.desktop})`,
	desktopL: `(min-width: ${size.desktop})`,
}

export const maxWidthDevice = {
	mobileS: `(max-width: ${size.mobileS})`,
	mobileL: `(max-width: ${size.mobileL})`,
}

export const customMinDeviceSize = (
	size: number,
	unit: 'px' | 'rem' = 'px'
): string => {
	return `(min-width: ${size}${unit})`
}
export const customMaxDeviceSize = (
	size: number,
	unit: 'px' | 'rem' = 'px'
): string => {
	return `(max-width: ${size}${unit})`
}
